import React, { createContext } from 'react'
const context = createContext({})

export default context